import Pockets from "@/pocket/Pockets";

export default [
    {
        path: '/pockets',
        component: Pockets
    },
];
